
import { useEffect, useState } from "react"
import url from "../api/url"
import { useEmpleadoStore } from "../stores/useEmpleadoStore"

const useDomicilio = () => {

    // variables
    const setToast = useEmpleadoStore( state => state.setToast )
    const objLogueado = useEmpleadoStore( state => state.objLogueado )
    const formInicial = {
        calle: '',
        numero: '',
        ciudad: '',
        estado: '',
        codigoPostal: '',
        codigoFiscal:'',
        colonia: ''
    }
    const { URL } = url()
    const [formDomicilio, setFormDomicilio] = useState( formInicial )
    const [cargando, setCargando] = useState( false )


    // funciones
    const traerDomicilio = () => {

        if ( !objLogueado.email ) return

        var fd = new FormData()
        fd.append("funcion", "traerDomicilio")
        fd.append("email", objLogueado.email)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            if ( e ) {
                setFormDomicilio({
                    ...e,
                    // codigoFiscal: e.codigo_fiscal,
                    codigoPostal: e.codigo_postal
                })
            }
        })
        .catch( a => {
            setToast( true )
            // alert("Error al traer los datos de tu domicilio. Puedes revisar tu conexión o iniciar sesión nuevamente.")
        });
    }


    const guardarDomicilio = () => {

        setCargando( true )
        fetch( URL, {
            method: 'post',
            body: JSON.stringify({ ...formDomicilio, funcion: 'guardarDomicilio', email: objLogueado.email })
        })
        .then( res => res.json() )
        .then( function (d) {
            alert( d.mensaje )
        })
        .catch( a => alert("Error al guardar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.") )
        .finally( () => setCargando( false ) )
    }

    // useEffects
    useEffect(() => {
        traerDomicilio()
        // eslint-disable-next-line
    }, [])


    return {
        guardarDomicilio, setFormDomicilio, formDomicilio, cargando
    }
}

export default useDomicilio
